// package: Olameter.WFMS.InventoryManagement.View.v1
// file: inv_view_service.proto

var inv_view_service_pb = require("./inv_view_service_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var inv_common_message_pb = require("./inv_common_message_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var ViewService = (function () {
  function ViewService() {}
  ViewService.serviceName = "Olameter.WFMS.InventoryManagement.View.v1.ViewService";
  return ViewService;
}());

ViewService.Healthz = {
  methodName: "Healthz",
  service: ViewService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: inv_common_message_pb.HealthzResponse
};

ViewService.Get = {
  methodName: "Get",
  service: ViewService,
  requestStream: false,
  responseStream: false,
  requestType: inv_view_service_pb.GetViewsRequest,
  responseType: inv_view_service_pb.ViewResponseCollection
};

ViewService.Save = {
  methodName: "Save",
  service: ViewService,
  requestStream: false,
  responseStream: false,
  requestType: inv_view_service_pb.SaveViewRequest,
  responseType: inv_view_service_pb.ViewResponse
};

ViewService.Delete = {
  methodName: "Delete",
  service: ViewService,
  requestStream: false,
  responseStream: false,
  requestType: inv_view_service_pb.DeleteViewRequest,
  responseType: inv_view_service_pb.ViewResponse
};

ViewService.UpdateLastSeen = {
  methodName: "UpdateLastSeen",
  service: ViewService,
  requestStream: false,
  responseStream: false,
  requestType: inv_view_service_pb.UpdateLastSeenViewRequest,
  responseType: inv_view_service_pb.ViewResponse
};

exports.ViewService = ViewService;

function ViewServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

ViewServiceClient.prototype.healthz = function healthz(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(ViewService.Healthz, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ViewServiceClient.prototype.get = function get(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(ViewService.Get, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ViewServiceClient.prototype.save = function save(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(ViewService.Save, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ViewServiceClient.prototype.delete = function pb_delete(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(ViewService.Delete, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

ViewServiceClient.prototype.updateLastSeen = function updateLastSeen(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(ViewService.UpdateLastSeen, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.ViewServiceClient = ViewServiceClient;

